type IconProps = {
	width?: number;
	height?: number;
	color?: string;
}

export const OverdueShipmentPaymentIcon = (props:IconProps) => {
	const {
		width = 18,
		height = 18,
		color = '#A60009'
	} = props;
	return (
		<svg role={'img'} width={width} height={height} viewBox={'0 0 18 18'} fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M3.75 6H14.25V4.5H3.75V6ZM3.75 16.5C3.3375 16.5 2.98438 16.3531 2.69063 16.0594C2.39688 15.7656 2.25 15.4125 2.25 15V4.5C2.25 4.0875 2.39688 3.73438 2.69063 3.44063C2.98438 3.14688 3.3375 3 3.75 3H4.5V1.5H6V3H12V1.5H13.5V3H14.25C14.6625 3 15.0156 3.14688 15.3094 3.44063C15.6031 3.73438 15.75 4.0875 15.75 4.5V8.75625C15.5125 8.64375 15.2688 8.55 15.0187 8.475C14.7687 8.4 14.5125 8.34375 14.25 8.30625V7.5H3.75V15H8.475C8.5625 15.275 8.66563 15.5375 8.78438 15.7875C8.90313 16.0375 9.04375 16.275 9.20625 16.5H3.75ZM13.5 17.25C12.4625 17.25 11.5781 16.8844 10.8469 16.1531C10.1156 15.4219 9.75 14.5375 9.75 13.5C9.75 12.4625 10.1156 11.5781 10.8469 10.8469C11.5781 10.1156 12.4625 9.75 13.5 9.75C14.5375 9.75 15.4219 10.1156 16.1531 10.8469C16.8844 11.5781 17.25 12.4625 17.25 13.5C17.25 14.5375 16.8844 15.4219 16.1531 16.1531C15.4219 16.8844 14.5375 17.25 13.5 17.25ZM14.7563 15.2812L15.2812 14.7563L13.875 13.35V11.25H13.125V13.65L14.7563 15.2812Z"
                fill={color}
            />
        </svg>
	);
};
